import React from 'react';
import { Hero } from './components/Hero';
import { PainValidation } from './components/PainValidation';
import { Solution } from './components/Solution';
import { Features } from './components/Features';
import { Benefits } from './components/Benefits';
import { Bonuses } from './components/Bonuses';
import { HowItWorks } from './components/HowItWorks';
import { Pricing } from './components/Pricing';
import { FinalCTA } from './components/FinalCTA';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  return <main className="min-h-screen w-full bg-[#fafaf9] font-sans text-stone-900 selection:bg-[#10b981]/20" data-id="element-0">
      <Hero data-id="element-1" />
      <PainValidation data-id="element-2" />
      <Solution data-id="element-3" />
      <Features data-id="element-4" />
      <Benefits data-id="element-5" />
      <Bonuses data-id="element-6" />
      <HowItWorks data-id="element-7" />
      <Pricing data-id="element-8" />
      <FinalCTA data-id="element-9" />

      <SocialProofPopup data-id="element-10" />

      <footer className="py-8 bg-stone-50 text-center text-stone-400 text-sm border-t border-stone-100" data-id="element-11">
        <div className="container mx-auto px-4" data-id="element-12">
          <p data-id="element-13">
            © {new Date().getFullYear()} Tu Vida Simple. Todos los derechos
            reservados.
          </p>
        </div>
      </footer>
    </main>;
}